import { render, staticRenderFns } from "./shortClock.vue?vue&type=template&id=b7c2990e&scoped=true"
import script from "./shortClock.vue?vue&type=script&lang=js"
export * from "./shortClock.vue?vue&type=script&lang=js"
import style0 from "./shortClock.vue?vue&type=style&index=0&id=b7c2990e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c2990e",
  null
  
)

export default component.exports